var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99994 5.58624C7.78095 6.36726 7.78099 7.63351 7.00003 8.41458L2.12164 13.2936C1.73113 13.6841 1.09795 13.6842 0.707428 13.2936C0.316927 12.9031 0.31693 12.27 0.707434 11.8795L5.58606 7.00082L0.706598 2.12131C0.316083 1.73079 0.316081 1.09764 0.706594 0.707117C1.09711 0.316588 1.73028 0.316584 2.12081 0.707109L6.99994 5.58624Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/Next.e6a5a60f6ae273f6e0423c833fe9358b.svg";
export { ForwardRef as ReactComponent };